import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import PortfolioSummaryModal from './PortfolioSummaryModal';
import PortfolioSummaryRow from './PortfolioSummaryRow';
import PortfolioTotal from './PortfolioTotal';
import { addCalculatedStats } from './addCalculatedStats';
import {
  AssetWithCalculatedStats,
  SortOption
} from '../../interfaces/interfaces';
import { Asset } from '../../../../api/src/interfaces/shared';

interface Props {
  assets: AssetWithCalculatedStats[];
}

interface State {
  summaryAssets: AssetWithCalculatedStats[];
  currentSort: SortOption;
  showModal: boolean;
  modalAsset?: AssetWithCalculatedStats;
}

export default class PortfolioSummary extends Component<Props, State> {
  /*
    This component shows the users portfolio (a list of assets).
  */

  static getSummary(
    assets: AssetWithCalculatedStats[]
  ): AssetWithCalculatedStats[] {
    const summary: Asset[] = [];
    assets.forEach(asset => {
      const summaryAsset = summary.find(e => e.externalId === asset.externalId);
      if (!summaryAsset) {
        summary.push({
          id: asset.id,
          type: asset.type,
          name: asset.name,
          percentChange: asset.percentChange,
          price: asset.price,
          lastUpdatedTimestamp: asset.lastUpdatedTimestamp,
          totalPrice: asset.totalPrice,
          stockholding: asset.stockholding,
          hourlyChange: asset.hourlyChange,
          weeklyChange: asset.weeklyChange,
          externalId: asset.externalId,
          transactionTimestamp: 0,
          userId: asset.userId
        });
      } else {
        summaryAsset.totalPrice += asset.totalPrice;
        summaryAsset.stockholding += asset.stockholding;
      }
    });
    const summaryWithCalculatedStats = summary.map(addCalculatedStats);
    return summaryWithCalculatedStats;
  }

  constructor(props: Props) {
    super(props);

    // Initialize the state with no equities and modal not showing.
    this.state = {
      showModal: false,
      summaryAssets: PortfolioSummary.getSummary(props.assets),
      currentSort: 'transactionTimestamp'
    };
  }

  showModal = (asset: AssetWithCalculatedStats) => {
    // Show the modal and set the modal to display the equity clicked.
    this.setState({ showModal: true, modalAsset: asset });
  };

  hideModal = () => {
    this.setState({ showModal: false });
  };

  sortAssets = (sortBy: SortOption) => {
    const { summaryAssets } = this.state;
    if (sortBy === this.state.currentSort) {
      summaryAssets.reverse();
    } else if (sortBy === 'name') {
      summaryAssets.sort((a, b) => a.name?.localeCompare(b?.name));
    } else {
      summaryAssets.sort((a, b) => b[sortBy] - a[sortBy]);
    }

    this.setState({
      summaryAssets,
      currentSort: sortBy
    });
  };

  render() {
    return (
      <div>
        <Table hover responsive className="summary-table" size="sm">
          <thead>
            <tr className="portfolio-header">
              <th className="sortable" onClick={() => this.sortAssets('name')}>
                Navn <span className="caret" />
              </th>
              <th
                className="sortable hide-on-650px"
                onClick={() => this.sortAssets('totalPrice')}
              >
                Investert <span className="caret" />
              </th>
              <th
                className="sortable hide-on-350px"
                onClick={() => this.sortAssets('lastUpdatedTimestamp')}
              >
                Oppdatert <span className="caret" />
              </th>
              <th
                className="sortable"
                onClick={() => this.sortAssets('percentChange')}
              >
                Siste dag <span className="caret" />
              </th>
              <th className="hide-on-374px">Kurs</th>
              <th
                className="sortable hide-on-500px"
                onClick={() => this.sortAssets('return')}
              >
                Avk. <span className="caret" />
              </th>
              <th
                className="sortable hide-on-580px"
                onClick={() => this.sortAssets('percentReturn')}
              >
                Avk. % <span className="caret" />
              </th>
              <th
                className="sortable"
                onClick={() => this.sortAssets('totalValue')}
              >
                Total Verdi <span className="caret" />
              </th>
            </tr>
          </thead>
          <tbody>
            {this.state.summaryAssets.map(asset => (
              <PortfolioSummaryRow
                key={asset.id}
                showModal={() => this.showModal(asset)}
                asset={asset}
              />
            ))}
            <PortfolioTotal assets={this.state.summaryAssets} isSummary />
            <tr className="if-no-results">
              <td colSpan={3}>Ingen rader funnet..</td>
              <td className="hide-on-650px" />
              <td className="hide-on-580px" />
              <td className="hide-on-374px" />
              <td className="hide-on-500px" />
              <td className="hide-on-350px" />
            </tr>
          </tbody>
        </Table>
        <PortfolioSummaryModal
          show={this.state.showModal}
          hide={this.hideModal}
          asset={this.state.modalAsset}
        />
      </div>
    );
  }
}
